import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { capitalize } from '../../../utils/utils';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import useMountEffect from '../../../mountEffect';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
const useStyles = makeStyles(theme => ({
  badge: {
    width: '20px',
    height: '20px',
    display: 'flex',
    zIndex: 1,
    flexWrap: 'wrap',
    fontSize: '0.75rem',
    alignItems: 'center',
    borderRadius: '50%',
    alignContent: 'center',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  newFeature: {
    padding: '2px 8px',
    borderRadius: '4px',
    backgroundColor: '#0fa855',
    color: 'white',
    fontSize: '12px',
    fontWeight: '600 !important',
    width: 'fit-content'
  },
  menuLink: {
    position: 'relative',
    display: 'block',
    color: 'inherit',
    textDecoration: 'none',
    "&:hover": {
      textDecoration: 'none'
    },
  },
  menuItem: {
    paddingLeft: 0,
    paddingRight: 0,
    fontSize: 14,
    fontWeight: 500,
    paddingTop: theme.spacing(1) * 1.5,
    paddingBottom: theme.spacing(1) * 1.5,
    '& .MuiTypography-root': {
      fontWeight: 300
    }
  },
  menuIcon: {
    marginLeft: theme.spacing(1) * 2,
    marginRight: theme.spacing(1) * 2
  },
  menuSubItem: {
    paddingLeft: '55px',
    paddingRight: '55px',
    paddingTop: theme.spacing(1) * 1.5,
    paddingBottom: theme.spacing(1) * 1.5
  },
  menuCollapsed: {
    // backgroundColor: theme.palette.action.hover
  },
  menuActive: {
    backgroundColor: '#0b1323',
    borderRadius: 4,
    color: '#fff',
    '& .MuiListItemIcon-root': {
      color: '#fff'
    },
    '& .premium-menu': {
      color: '#fcda6f !important'
    }
  },
  menuClosed: {
    backgroundColor: 'transparent'
  },
  caret: {
    marginLeft: theme.spacing(1) * 2,
    marginRight: theme.spacing(1) * 2,
    minWidth: 0
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText
  },
  mrV1: {
    marginRight: 4
  }
}));

const SidebarItem = ({
  route,
  index,
  activeRoute,
  toggleMenu,
  currentPath,
  payments,
  user
}) => {
  const classes = useStyles();
  let disabledMenu = false;
  let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
  let premEnabled = user && user.configs && user.configs.subscription && user.configs.subscription.enabled && user.configs.subscription.enabled == 1 ? true : false;
  if (userInfo && userInfo.userInfo && userInfo.userInfo.role && userInfo.userInfo.role != "USER" && ((payments && payments.subscriptionStatus
    && typeof payments.subscriptionStatus.isExpired != 'undefined' && payments.subscriptionStatus.isExpired) ||
    (userInfo && typeof userInfo.isSubscriptionActive != 'undefined' && !userInfo.isSubscriptionActive))
    && (route && typeof route.name != "undefined" && route.name != "Premium")
  ) {
    disabledMenu = true;
  }
  useMountEffect(() => {
    if (!currentPath || activeRoute === index || route.path === '/') return;
    toggleMenu(index);
  });

  const badge = badge => {
    if (!badge) return;
    const badgeClassName = classNames(classes.badge, {
      [classes[`${badge.type}`]]: badge.type !== 'default'
    });
    return (
      <Typography
        className={classNames(classes.badge, badgeClassName)}
        component="div"
      >
        {badge.value}
      </Typography>
    );
  };


  if (!premEnabled && (route && typeof route.name != "undefined" && route.name == "Premium")) {
    return null
  }
  if (route.type === 'external' && route.visible) {
    return (
      <a
        href={route.path}
        target="_blank"
        rel="noopener noreferrer"
        key={index}
        className={classes.menuLink}
      >
        <ListItem className={classes.menuItem} button>
          <ListItemIcon>
            <route.icon className={classes.menuIcon} />
          </ListItemIcon>
          <Typography variant="body1" className={route && route.className ? route.className + " flexSpacer" : "flexSpacer"}>
            {capitalize(route.name)}
          </Typography>
          {badge(route.badge)}
        </ListItem>
      </a>
    );
  }

  if (route.type === 'submenu' && route.visible) {
    return (
      <div
        className={
          activeRoute === index ? classes.menuCollapsed : classes.menuClosed
        }
      >
        <NavLink
          to={{
            pathname: route.path,
            state: route.state ? route.state : {}
          }}
          //exact
          className={classNames(classes.menuLink, disabledMenu ? 'disabled-menu' : '')}
          activeClassName={classes.menuActive}
          key={index}
        >
          <ListItem
            className={classes.menuItem}
            button
            key={index}
          >
            <ListItemIcon>
              <route.icon className={classes.menuIcon} />
            </ListItemIcon>
            <Typography variant="body1" className={route && route.className ? route.className + " flexSpacer" : "flexSpacer"}>
              {capitalize(route.name)}
            </Typography>
            <span className={classes.mrV1}>
              {badge(route.badge)}
            </span>
            {/* {badge(route.badge)}
            <ListItemIcon onClick={() => toggleMenu(index)} className={classes.caret}>
              {activeRoute === index ? (
                <ArrowDropUpIcon />
              ) : (
                <ArrowDropDownIcon />
              )}
            </ListItemIcon> */}
          </ListItem>
        </NavLink>
        {/* <Collapse
          in={activeRoute === index ? true : false}
          timeout="auto"
          unmountOnExit
        >
          <List disablePadding>
            {route.children.map((subitem, index) => (
              <NavLink
                to={`${route.path ? route.path : ''}${
                  subitem.path ? subitem.path : ''
                }`}
                exact
                className={classes.menuLink}
                activeClassName={classes.menuActive}
                key={index}
              >
                <ListItem className={classes.menuSubItem} button>
                  <Typography variant="body1" className="flexSpacer">
                    {capitalize(subitem.name)}
                  </Typography>
                  {badge(subitem.badge)}
                </ListItem>
              </NavLink>
            ))}
          </List>
        </Collapse> */}
      </div>
    );
  }

  return route.visible ? (
    <NavLink
      to={{
        pathname: route.path,
        state: route.state ? route.state : {}
      }}
      exact
      className={classNames(classes.menuLink, disabledMenu ? 'disabled-menu' : '')}
      activeClassName={classes.menuActive}
      key={index}
    >
      <ListItem
        className={classes.menuItem}
        button
        onClick={() => toggleMenu(index)}
      >
        <ListItemIcon>
          <route.icon className={classes.menuIcon} />
        </ListItemIcon>
        <Typography variant="body1" className={route && route.className ? route.className + " flexSpacer" : "flexSpacer"}>
          {capitalize(route.name)}
        </Typography>
        <span className={classes.mrV1}>
          {badge(route.badge)}
        </span>
      </ListItem>
    </NavLink>
  ) : null;
};

SidebarItem.prototypes = {
  route: PropTypes.object,
  index: PropTypes.number,
  activeRoute: PropTypes.number,
  toggleMenu: PropTypes.func
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
});
const SidebarItemWithRouter = withRouter(SidebarItem);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SidebarItemWithRouter);